// extracted by mini-css-extract-plugin
export default {"menuBlock":"CG-z","title":"DG-z","nav":"EG-z","flexCell":"FG-z","facetLink":"GG-z"};